// extracted by mini-css-extract-plugin
export default {"icon":"Orders_icon__0nW+b","activeIcon":"Orders_activeIcon__gi+kj"};